export const DEFAULT_ANIMATION_DURATION = 0.2;

export const AnimatedSvgIds = {
  animatedSvg: 'animatedSvg',
  animatedTagPath: 'animatedPath',
  animateTagForward: 'animateForward',
  animateTagBackward: 'animateBackward',
};

export enum AnimationDirection {
  FORWARD = 'Forward',
  BACKWARD = 'Backward',
}

export const AnimatedDataAttributes = {
  [AnimationDirection.FORWARD]: 'data-animated-end-path',
  [AnimationDirection.BACKWARD]: 'data-animated-start-path',
};

export const TestIds = {
  animatedSvg: 'animated-svg',
  animateTagForward: 'animate-tag-forward',
  animateTagBackward: 'animate-tag-backward',
  fallbackPath: 'fallback-path',
};

export const DesignStates = {
  root: {
    hover: { displayName: 'Hover', className: 'animated-icon--hover' },
    disabled: { displayName: 'Disabled', className: 'animated-icon--disabled' },
    selected: { displayName: 'Selected', className: 'animated-icon--selected' },
  },
} as const;

export const DisplayNames = {
  root: {
    elementDisplayName: 'Animated Icon',
    customActions: {
      animatedIcon: {
        IconCreationPanel: {
          title: 'Create an animated icon',
          backButton: 'Back',
          startIcon: 'Start icon',
          endIcon: 'End icon',
          addImageInfo: 'Add',
          updateImageInfo: 'Replace',
          hoverToPreview: 'Hover to preview',
          error: 'Error',
          generatingAnimation: 'Loading animation...',
          emptyStateTitle:
            'Add start and end icons to create the animated icon',
          sectionHelper: 'Improve your animation with our guidelines.',
          sectionHelperLink: 'View Guidelines',
        },
        displayName: 'Icon',
        panel: {
          chooseIcon: 'Choose an icon',
          replaceIcon: 'Replace',
          AnimatedIconCreationButton: 'Create Animated Icon',
          duration: 'Duration',
          startIcon: 'Start icon',
          iconType: {
            displayName: 'Icon type',
            tooltip:
              'Choose a static icon, or an animated icon that moves on hover (desktop) or tap (mobile).',
            options: { static: 'Static', animated: 'Animated' },
          },
        },
      },
    },
    data: {
      duration: 'Duration',
    },
    cssCustomProperties: {
      size: 'Size',
      fill: 'Color',
      rotation: 'Rotation',
    },
  },
};
